import script from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CardTemplate.vue?vue&type=style&index=0&id=628d0263&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628d0263"]])

export default __exports__